import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1280px;
	display: flex;
	flex-direction: column;
	gap: 4.5rem;
	margin: 3rem auto;
	padding: 1.5rem;
`;
